import { type Bürgschaftsart as Buergschaftsart } from '@/types/Bürgschaft.ts';
import type { Kautionsvertrag } from '@/types/Vertrag.ts';

export const SUBLIMIT_ANTEIL = {
  GESAMTWERT: 'GESAMTWERT',
  ANTEIL: 'ANTEIL',
} as const;
export type SublimitAnteilOptions = (typeof SUBLIMIT_ANTEIL)[keyof typeof SUBLIMIT_ANTEIL];

export const SUBLIMIT = {
  KEINE: 'KEINE',
  VORHANDEN: 'VORHANDEN',
} as const;
export type SublimitOptions = (typeof SUBLIMIT)[keyof typeof SUBLIMIT];

export const RahmenVertragsModell = {
  GESAMTRAHMEN: 'GESAMTRAHMEN',
  JAHRESRAHMEN: 'JAHRESRAHMEN',
} as const;
export type RahmenVertragsModellOptions =
  (typeof RahmenVertragsModell)[keyof typeof RahmenVertragsModell];

export interface AvallinieAuslastung {
  auftragSumme: number | null;
  buergschaftSumme: number | null;
}

interface LinieBasis {
  id: number | null;
  gesamtwert: number; // in Cent
  einzelwert: number; // in Cent
  stichtag: string;
  auslastungStichtag: number; // in Cent
  zinssatz: number;
  auslastung?: AvallinieAuslastung | null;
  modell?: RahmenVertragsModellOptions | null;
  kalenderjahr?: number | null;
}

export interface Sublimit extends LinieBasis {
  gesamtwertAnteil?: number | null;
  modus: SublimitAnteilOptions | null;
  buergschaftsarten: Buergschaftsart[];
  datumLetzteAusstellung: string | null;
}

export interface Avallinie extends LinieBasis {
  buergeId: string | null;
  auftraggeberId: string | null;
  sublimits: Sublimit[];
  kautionsvertragList?: Kautionsvertrag[];
  kautionsvertragIds?: number[];
  datumLetzteAusstellung: string | null;
}

export interface AvallinieListItem extends LinieBasis {
  auslastung: AvallinieAuslastung | null;
  buergeId: string;
  auftraggeberId: string | null;
  hasSublimits: boolean;
  minZinssatz: number;
  maxZinssatz: number;
  vertraege: string;
  datumLetzteAusstellung: string;
}

export interface AvalLite {
  zinssatz?: string;
  gesamtwert?: number;
  einzelwert?: number;
  stichtag?: string;
  gesamtwertAnteil?: number | null;
  gesamtWertCalculated?: number | null;
  modus?: SublimitAnteilOptions | null;
  buergschaftsarts?: Buergschaftsart[];
  datumLetzteAusstellung?: string;
  auslastung: AvallinieAuslastung | null;
  modell?: RahmenVertragsModellOptions | null;
  kalenderjahr?: number | null;
}

export function createEmptyAvallinie(): Avallinie {
  return {
    id: null,
    buergeId: null,
    auftraggeberId: null,
    gesamtwert: null,
    einzelwert: null,
    stichtag: null,
    auslastungStichtag: null,
    zinssatz: null,
    sublimits: [createEmptySublimit()],
    auslastung: null,
    datumLetzteAusstellung: null,
    modell: null,
    kalenderjahr: null,
  };
}

export function createEmptySublimit(): Sublimit {
  return {
    id: null,
    gesamtwert: null,
    einzelwert: null,
    gesamtwertAnteil: null,
    modus: null,
    stichtag: null,
    auslastungStichtag: null,
    zinssatz: null,
    buergschaftsarten: [],
    auslastung: null,
    datumLetzteAusstellung: null,
  };
}
